import PolicyHtmlContent from "./PolicyHtmlContent";

export default PolicyHtmlContent;
